import { useMemo } from "react";
import { ClientProviderEnum } from "../../../../constants";
import { PageContextUtils } from "../../../../utils";
import { useKambiMenuItemsPC } from "./Kambi/useKambiMenuItemsPC";
import { useKambiNumberOfItemsPC } from "./Kambi/useKambiNumberOfItemsPC";
import { useSpectateMenuItemsPC } from "./Spectate/useSpectateMenuItemsPC";
import { useSpectateNumberOfItemsPC } from "./Spectate/useSpectateNumberOfItemsPC";

export const usePCCategories = () => {
  const { name } = PageContextUtils.getClientProviderData();
  const useNumberOfItems = useMemo(
    () =>
      name === ClientProviderEnum.Kambi
        ? useKambiNumberOfItemsPC
        : name === ClientProviderEnum.Spectate
          ? useSpectateNumberOfItemsPC
          : () => {},
    [name]
  );

  useNumberOfItems();

  const useMenuItems = useMemo(
    () =>
      name === ClientProviderEnum.Kambi
        ? useKambiMenuItemsPC
        : name === ClientProviderEnum.Spectate
          ? useSpectateMenuItemsPC
          : () => {},
    [name]
  );

  return useMenuItems();
};
